import { Answer, InputType, Question, Sku } from 'types/sku.types';
import { IHash } from 'types/base.types';
import { Maybe } from 'types/util.types';

export type QAErrors = IHash<string> | IHash<IHash<string>>;
export type ErrorHashProp = IHash<string>;

export enum CustomDropdownValues {
  negOne = -1,
  empty = '',
  zero = 0,
}

export enum QuestionTypes {
  Dropdown = 'dropdown',
  Checkbox = 'checkbox',
  Textarea = 'textarea',
  Input = 'input',
  Device = 'device',
}

export type ModelAnswer = Answer & {
  productQuestion: ProductQuestion;
};

export type ProductQuestion = {
  id: number;
  text: string;
  answers: {
    id: number;
    name: string;
  }[];
};

export type QuestionDeviceProps = {
  question: QuestionsAPIByQuestion;
  sku: Sku;
  error: ErrorHashProp;
  value: string | number;
  modelValue: number | string;
  makeInputValue: Maybe<undefined | string>;
  modelInputValue: number | string;
  onMakeDropdownChange: BaseAnyFunction;
  onModelDropdownChange: BaseAnyFunction;
  onMakeInputChange: BaseAnyFunction;
  onModelInputChange: BaseAnyFunction;
  onIconClick: BaseAnyFunction;
};

export type ActionDeviceProps = {
  questionType: string;
  question: Question;
  makeInputValue?: string | number;
  modelInputValue?: string | number;
  makeValue?: Maybe<number | string>;
  modelValue?: Maybe<number | string>;
};

export type QuestionsAPIByQuestion = {
  answers: Array<Answer | ModelAnswer>;
  hint: Maybe<string>;
  id: number | string;
  inputType: InputType;
  required: boolean;
  serviceId: Maybe<number>;
  textDirect: string;
};
